import { Paper, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'

//Common styles
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from '../../styles/commonStyles'

const HEADER_ROW_SX = { backgroundColor: 'rgba(232, 235, 237, 0.3) !important' }

function ComboDiscountTable(props: any) {
  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Pack Discount</Title>
      </TableTopHeader>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '8px',
          // roomier rows so the list doesn't look compact
          '& tbody td': { paddingTop: '18px', paddingBottom: '18px' },
        }}
      >
        <StyledTable sx={{ minWidth: { xs: 640, md: 'auto' } }}>
          <TableHead>
            {/* Parent Headers */}
            <TableRow sx={HEADER_ROW_SX}>
              <TableHeader rowSpan={2}>Time</TableHeader>
              <TableHeader rowSpan={2}>Cook Utilisation</TableHeader>
              <TableHeader rowSpan={2}>Pack Discount</TableHeader>
              <TableHeader colSpan={2}>Pack Utilisation Past</TableHeader>
              <TableHeader colSpan={2}>Pack Utilisation Future</TableHeader>
            </TableRow>
            {/* Sub-Headers */}
            <TableRow sx={HEADER_ROW_SX}>
              <TableHeader>Total</TableHeader>
              <TableHeader>No. of 30 Days Pack</TableHeader>
              <TableHeader>Total</TableHeader>
              <TableHeader>Last 30 Days</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(props?.discountData).map(([time, details]: any) => (
              <CustomTableRowTR key={time}>
                <TableData>{time}</TableData>
                <TableData>{details?.cookUtilisation}</TableData>
                <TableData>{details?.comboDiscount}</TableData>
                <TableData>
                  {details.comboUtilisationPast?.totalComboUtilisation}
                </TableData>
                <TableData>
                  {details.comboUtilisationPast?.comboUtilisation30Days}
                </TableData>
                <TableData>
                  {details.comboUtilisationFuture?.totalComboUtilisation}
                </TableData>
                <TableData>
                  {details.comboUtilisationFuture?.comboUtilisation30Days}
                </TableData>
              </CustomTableRowTR>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  )
}

export default ComboDiscountTable
